import { render, staticRenderFns } from "./ScalingUp.vue?vue&type=template&id=62db9264&scoped=true&"
import script from "./ScalingUp.vue?vue&type=script&lang=js&"
export * from "./ScalingUp.vue?vue&type=script&lang=js&"
import style0 from "./ScalingUp.vue?vue&type=style&index=0&id=62db9264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db9264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62db9264')) {
      api.createRecord('62db9264', component.options)
    } else {
      api.reload('62db9264', component.options)
    }
    module.hot.accept("./ScalingUp.vue?vue&type=template&id=62db9264&scoped=true&", function () {
      api.rerender('62db9264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/ScalingUp.vue"
export default component.exports